export function degToRad(degrees) {
  var pi = Math.PI
  return degrees * (pi / 180)
}

